// Animated number: counts from the previous value up (or down) to `value`
// with an ease-out. Shows the final value straight away when the viewer
// prefers reduced motion.

function prefersReducedMotion() {
  return typeof window !== "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export default {
  name: "CountUp",
  props: {
    value: { type: Number, default: 0 },
    duration: { type: Number, default: 1100 },
    decimals: { type: Number, default: 0 },
    prefix: { type: String, default: "" },
    suffix: { type: String, default: "" },
  },
  data() {
    return { shown: 0, frame: null };
  },
  watch: {
    value: {
      immediate: true,
      handler(to, from) {
        this.animate(Number(from) || 0, Number(to) || 0);
      },
    },
  },
  beforeDestroy() {
    if (this.frame) cancelAnimationFrame(this.frame);
  },
  methods: {
    animate(from, to) {
      if (this.frame) cancelAnimationFrame(this.frame);
      if (from === to || prefersReducedMotion() || typeof requestAnimationFrame === "undefined") {
        this.shown = to;
        return;
      }
      const start = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - start) / this.duration);
        const eased = 1 - Math.pow(1 - t, 3);
        this.shown = from + (to - from) * eased;
        this.frame = t < 1 ? requestAnimationFrame(step) : null;
      };
      this.frame = requestAnimationFrame(step);
    },
  },
  render(h) {
    const text = Number(this.shown).toLocaleString("en-IN", {
      minimumFractionDigits: this.decimals,
      maximumFractionDigits: this.decimals,
    });
    return h("span", { class: "count-up" }, this.prefix + text + this.suffix);
  },
};
